import { FC } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

import Grid from '@material-ui/core/Grid';

import AccountsPayableCustomTable from '@components/AccountsPayableCustomTable';

import useStore from '@hooks/useStore';
import useAccountsPayableFireBase from '@hooks/useAccountsPayableFireBase';
import { formattedAmount } from '@utils/format';
import useStyles from './../styles';

export interface IValidation {}

const Validation: FC<IValidation> = () => {
  const { accountsPayableLink } = useStore();
  const { fundInfo, accountsPayable } = accountsPayableLink;
  const { getTotalAmount, canProcess, canNotProcess, inProcess } = accountsPayable;
  const css = useStyles();

  const inProcessRows = [...toJS(inProcess)];
  const canProcessRows = [...toJS(canProcess)];
  const canNotProcessRows = [...toJS(canNotProcess)];

  useAccountsPayableFireBase({});

  return (
    <div className={css.card}>
      <AccountsPayableCustomTable
        autoRefreshTotals={true}
        canSelect={false}
        isInProcess
        grouped
        group="Dispersiones en proceso"
        rows={inProcessRows}
        groupedTotalRows={inProcessRows.length}
        groupedRowsIds={inProcessRows.map((item) => item.accountPayableId)}
      />
      <AccountsPayableCustomTable
        autoRefreshTotals={true}
        canSelect={false}
        grouped
        group="Dispersiones realizadas"
        statusSuccessLabel="Dispersion realizada"
        rows={canProcessRows}
        groupedTotalRows={canProcessRows.length}
        groupedRowsIds={canProcessRows.map((item) => item.accountPayableId)}
      />
      <AccountsPayableCustomTable
        autoRefreshTotals={true}
        canSelect={false}
        grouped
        group="Dispersiones no realizadas"
        statusErrorLabel="No se pudo dispersar"
        rows={canNotProcessRows}
        groupedTotalRows={canNotProcessRows.length}
        groupedRowsIds={canNotProcessRows.map((item) => item.accountPayableId)}
      />
      <Grid container spacing={3} className={css.containerButtons}>
        <Grid item xs={12} md={8} />
        <Grid item xs={12} md={4}>
          <Grid container className={css.containerAmount}>
            <Grid item xs={8} md={6}>
              Total dispersado
            </Grid>
            <Grid item xs={4} md={6} className={css.totalAmountContainer}>
              {formattedAmount(getTotalAmount, fundInfo.currency)}{' '}
              <span className={css.totalAmountCurrency}>{fundInfo.currency}</span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default observer(Validation);
